import getSlugFromUrl from '@/utils/getSlugFromUrl';

export default defineNuxtPlugin(() => {
  const { $logger, $sendCustomYandexMetrika } = useNuxtApp();

  const log = $logger.withScope('🚩🔗 clickOutside');

  function linkClickHandler(event: MouseEvent) {
    const currentSlug = getSlugFromUrl(window.location.href);
    const link = (event.target as HTMLElement)?.closest('a');

    if (!link) return;

    log('link click', link?.href);
    $sendCustomYandexMetrika({
      // * аналитик попросил сделать такую структуру
      outer_transition: { [currentSlug]: [link?.href] },
    });
  }

  document.addEventListener('click', linkClickHandler, { passive: true });
});
